import angular from 'angular';
import languageManager from '../../../cmsCore/Language/LanguageManager';
import './linearChart.scss';

export default angular.module('cms.chart.linearChart', [languageManager])
    .component('cmsLinearChart', {
        bindings: {
            callbackPromise: '<',
            chartId: '@',
            options: '='
        },
        template: require('./linearChart.html'),
        controller: function (baConfig, layoutPaths, baUtil, $http, $scope, languageManager) {

            let layoutColors = baConfig.colors;
            let chart;

            this.$onInit = () => {
                this.callbackPromise().then(function (response) {
                    printChart(response.data);
                });
            };

            let printChart = (chartData) => {

                let chartOptions = angular.merge({
                    type: 'serial',
                    theme: 'light',
                    language: languageManager.getLanguage(),
                    dataDateFormat: "DD/MM/YYYY",
                    marginTop: 15,
                    marginRight: 15,
                    dataProvider: chartData,
                    categoryField: 'date',
                    categoryAxis: {
                        gridAlpha: 0,
                        parseDates: true,
                        minPeriod: 'DD',
                        color: layoutColors.defaultText,
                        axisColor: layoutColors.defaultText
                    },
                    valueAxes: [
                        {
                            minVerticalGap: 50,
                            gridAlpha: 0,
                            color: layoutColors.defaultText,
                            axisColor: layoutColors.defaultText
                        }
                    ],
                    graphs: [
                        {
                            id: 'g1',
                            bullet: 'none',
                            lineColor: layoutColors.danger,
                            lineThickness: 1,
                            type: 'smoothedLine',
                            valueField: 'deleted',
                            fillAlphas: .1,
                            fillColorsField: 'lineColor'
                        }
                    ],
                    creditsPosition: 'bottom-right',
                    zoomControl: {
                        zoomControlEnabled: false

                    }
                }, this.options);

                chart = AmCharts.makeChart(this.chartId, chartOptions);
            };

            $scope.$on('language-changed', (event, data) => {
                if (chart && data.newLanguage) {
                    chart.language = data.newLanguage;
                    chart.validateData();
                }
            });

        }
    }).name;


// WEBPACK FOOTER //
// ./src/cmsCore/Chart/LinearChart/linearChart.js